<template>
  <!--
:class="this.$vuetify.theme.dark == true?'grey darken-4':'grey lighten-4'"
    -->
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="3" lg="3" sm="4" class>
        <p class="google-font mb-0" style="font-size:200%">
          {{ roomData.name }}
        </p>

        <p class="google-font mt-0" style="font-size:95%">
          {{ roomData.thema }}
        </p>
        <v-btn
          rounded
          block
          color="red"
          style="text-transform: capitalize;border-radius:5px;text-transform: capitalize;"
          
          small
          @click="leaveRoom()"
          dark
          >Raum verlassen</v-btn>
        <v-divider></v-divider>
        <v-container fluid>
          <v-list shaped>
            <v-subheader>User in diesem Raum</v-subheader>
            <v-list-item-group color="primary">
              <v-list-item v-for="(user, i) in roomData.users" :key="i">
                <v-list-item-icon>
                  <v-icon>{{ user.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="user.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-container>

        <v-divider></v-divider>
      </v-col>
      <v-col
        cols="12"
        md="9"
        lg="9"
        sm="8"
        class="scrollable chatBox"
        id="chatbox"
      >
        <v-container fluid>
          <v-row
            style=""
            v-for="(nachricht, index) in roomData.nachrichten"
            :key="index"
            :class="
              nachricht.user !== userName ? 'nachrichtright' : 'nachrichtleft'
            "
          >
            <v-col md="12" lg="12" sm="12" cols="12" class="text-center pa-2">
              <p class="google-font mt-2 nachrichtHeader">
                {{ nachricht.user }} - {{ nachricht.time }}
              </p>

              <p class="google-font nachrichtText">
                {{ nachricht.nachricht }}
              </p>
            </v-col>
            <v-divider></v-divider>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col md="3" lg="3" sm="3" cols="12">
        <p class="google-font mb-0" style="font-size:130%;color: #1a73e8;">
          Nachricht schreiben
        </p>
      </v-col>
      <v-col md="7" lg="7" sm="7" cols="12">
        <v-text-field
          flat
          @keyup.enter="sendNachricht()"
          v-model="nachricht"
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-pencil"
          label="Nachricht..."
          single-line
        ></v-text-field>
      </v-col>
      <v-col md="2" lg="2" sm="2" cols="12">
        <v-btn
          rounded
          block
          :disabled="!nachricht"
          color="blue"
          style="text-transform: capitalize;border-radius:5px;text-transform: capitalize;"
          outlined
          large
          @click="sendNachricht()"
          dark
          >Senden</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as socket from "@/plugins/socketio.js";
import { mapState, mapGetters } from "vuex";
export default {
  name: "ChatRoom",
  data: () => ({
    userName: null,
    nachricht: null,
  }),
  props: {
    roomData: Object,
  },
  computed: {
    ...mapState(["config", "currentUser"]),
    ...mapGetters({
      currentUser: "currentUser",
    }),
  },
  created(){
    this.userName = this.currentUser.niceName;
  },
  methods: {
    sendNachricht() {
      if(this.nachricht){
var sendNachrichtEvent = {
        type: "SendNachricht",
        data: {
          hash: this.currentUser.userHash,
          user: this.currentUser.niceName,
          roomName: this.roomData.name,
          nachricht: this.nachricht,
        },
      };
      socket.sendEvent(sendNachrichtEvent);
      this.nachricht = null;
      }
      
    },
    leaveRoom(){
      var sendLeaveEvent = {
        type: "LeaveRoom",
        data: {
          hash: this.currentUser.userHash,
          user: this.currentUser.niceName,
          roomName: this.roomData.name,
        },
      };
      socket.sendEvent(sendLeaveEvent);
    },
    
  },
};
</script>
<style scoped>
.scrollable {
  overflow-y: auto;
}
.chatBox {
  height: 50vh;
}
.nachrichtleft {
  width: 70%;
  float: left;
  border-radius: 25px;
  background-color: #1a73e8;
  opacity: 0.9;
  margin: 2px;
  padding: 3px;
  color: white;
}
.nachrichtright {
  width: 70%;
  float: right;
  background-color: #474747;
  opacity: 0.9;
  border-radius: 25px;
  margin: 2px;
  padding: 3px;
  color: white;
}
.nachrichtHeader {
  font-size: 80%;
  text-align: left;
  border-bottom: 1px solid grey;
}
.nachrichtText {
  font-size: 100%;
  margin: 1px;
  text-align: left;
}
</style>
